<template>
  <tk-flex middle center class="camera_ctl_panel">
    <tk-flex>
      <div class="panel_direction m-r-15">
        <tk-flex middle center class="direction_center">
          <Center />
        </tk-flex>
        <Left
          class="direction_icon"
          style="left: 0; top: 50%; transform: translateY(-50%);"
          @mousedown.native="$emit('left')"
          @mouseup.native="$emit('stopMove')"
        />
        <Top
          class="direction_icon"
          style="left: 50%; top: 0; transform: translateX(-50%);"
          @mousedown.native="$emit('top')"
          @mouseup.native="$emit('stopMove')"
        />
        <Right
          class="direction_icon"
          style="right: 0; top: 50%; transform: translateY(-50%);"
          @mousedown.native="$emit('right')"
          @mouseup.native="$emit('stopMove')"
        />
        <Bottom
          class="direction_icon"
          style="left: 50%; bottom: 0; transform: translateX(-50%);"
          @mousedown.native="$emit('bottom')"
          @mouseup.native="$emit('stopMove')"
        />
      </div>
      <tk-flex column center>
        <ZoomIn
          class="m-b-15"
          @mousedown.native="$emit('zoomIn')"
          @mouseup.native="$emit('stopZoom')"
        />
        <ZoomOut
          @mousedown.native="$emit('zoomOut')"
          @mouseup.native="$emit('stopZoom')"
        />
      </tk-flex>
    </tk-flex>
  </tk-flex>
</template>
<script>
import ZoomIn from './zoomIn.vue'
import ZoomOut from './zoomOut.vue'
import Center from './center'
import Left from './left'
import Top from './top'
import Right from './right'
import Bottom from './bottom'
export default {
  components: {
    ZoomIn,
    ZoomOut,
    Center,
    Left,
    Top,
    Right,
    Bottom
  }
}
</script>
<style scoped>
.camera_ctl_panel {
  width: 168px;
  height: 120px;
}
.panel_direction {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 2px solid #dde0e5;
}
.direction_icon {
  position: absolute;
}
.direction_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #dde0e5;
}
</style>
